import { render, staticRenderFns } from "./homeWork.vue?vue&type=template&id=9bae16c4&scoped=true"
import script from "./homeWork.vue?vue&type=script&setup=true&lang=js"
export * from "./homeWork.vue?vue&type=script&setup=true&lang=js"
import style0 from "./homeWork.vue?vue&type=style&index=0&id=9bae16c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae16c4",
  null
  
)

export default component.exports